export const BG_PRIMARY = '#BC997D';
export const BG_SECONDARY = '#EFDCC0';
export const BG_ALTERNATIVE = '#FFFFFF';
export const BG_OPACITY = 'rgb(227 167 75)';

export const TEXT_PRIMARY = '#FFFFFF';
export const TEXT_SECONDARY = '#E3A74B';
export const TEXT_ALTERNATIVE = '#BC997D';

export const NAVIGATION_COLOR = '#914d22';
export const ICON_NAVIGATION_COLOR = '#FFFFFF';

export const DEFAULT_BUTTON_PROPS = '';
